import { Outlet, useLocation, useNavigate, Link } from 'react-router-dom'
import { ArrowLeft, Monitor, LogOut } from 'lucide-react'
import { useAuth } from '@/lib/auth'

const TITLES_M: Record<string, string> = {
  '/m/inventarios': 'Inventários',
}

export default function MobileLayout() {
  const loc = useLocation()
  const navigate = useNavigate()
  const { logout, empresa } = useAuth()

  // Detecta titulo dinamicamente
  let title = TITLES_M[loc.pathname] || 'VELORE ERP'
  if (loc.pathname.match(/^\/m\/inventarios\/\d+/)) title = 'Inventário'

  const podeVoltar = loc.pathname !== '/m/inventarios'

  return (
    <div className="min-h-screen bg-ink-50 flex flex-col">
      {/* Top bar fina */}
      <header className="sticky top-0 z-20 bg-brand-600 text-white shadow-sm">
        <div className="h-12 px-3 flex items-center gap-2">
          {podeVoltar ? (
            <button
              onClick={() => navigate(-1)}
              className="p-1.5 -ml-1 rounded hover:bg-brand-700 active:bg-brand-800"
            >
              <ArrowLeft size={20} />
            </button>
          ) : (
            <div className="w-8 h-8 rounded bg-white/20 flex items-center justify-center font-bold text-sm">
              P
            </div>
          )}
          <h1 className="text-base font-semibold flex-1 truncate">{title}</h1>
          <button
            onClick={() => navigate('/')}
            title="Abrir versão desktop"
            className="p-1.5 rounded hover:bg-brand-700 active:bg-brand-800"
          >
            <Monitor size={18} />
          </button>
          <button
            onClick={() => { logout(); navigate('/login') }}
            title="Sair"
            className="p-1.5 rounded hover:bg-brand-700 active:bg-brand-800"
          >
            <LogOut size={18} />
          </button>
        </div>
        {empresa?.nome_fantasia && (
          <div className="px-3 pb-1 text-xs text-white/80 truncate">
            {empresa.nome_fantasia}
          </div>
        )}
      </header>

      {/* Main */}
      <main className="flex-1 p-3 overflow-auto">
        <Outlet />
      </main>

      {/* Rodape curtinho */}
      <footer className="text-center text-xs text-ink-400 py-2 border-t border-ink-200 bg-white">
        VELORE ERP · Desenvolvido por <span className="font-medium text-ink-500">DN Tecnologia</span>
      </footer>
    </div>
  )
}
